export class ContractDetail {
	public id: number;
	public contractId: string;
	public supplierCommissionResponseReasonId: number;
	public supplierNote: string;
	public complianceDate: Date;

	constructor(contractDetail?: ContractDetail) {
		Object.assign(this, contractDetail);

		if (this.complianceDate) {
			this.complianceDate = new Date(this.complianceDate);
		}
	}
}
